// Función para mapear datos del formulario al formato de Tecnóm
const isLlamadaMedio = (value) => typeof value === "string" && value.trim().toLowerCase() === "llamada";

export const mapFormDataToTecnom = (formData) => {
  const currentDate = new Date().toISOString();

  // Mapear el tipo de operación según la selección del usuario
  // tipoPlan puede ser "plan" o "venta directa" o similar
  const operationType =
    formData.tipoPlan === "plan"
      ? "Plan de Ahorro"
      : formData.tipoPlan === "venta directa" || formData.tipoPlan === "directa"
      ? "Venta Directa"
      : formData.tipoPlan || "Consulta";

  // Determinar el origen basado en utm_source o usar GOOGLE por defecto
  let origin = formData.utm_source || "GOOGLE";

  // Suborigen hardcodeado como "web"
  const suborigen = "web";

  // Limpiar el teléfono (remover espacios)
  const cleanPhone = formData.phone ? formData.phone.replace(/\s+/g, "") : "";

  // Construir la descripción del vehículo para comments
  let vehicleDescription = "";
  if (formData.vehicle) {
    vehicleDescription = formData.vehicle;
  } else if (formData.vModelo) {
    vehicleDescription = `${formData.brand || ""} ${formData.vModelo}`.trim();
    if (formData.vVersion) {
      vehicleDescription += ` ${formData.vVersion}`;
    }
  }

  // Construir el objeto vehicle solo si tenemos datos de identificación válidos
  // La API requiere al menos registration_plate o vin_vis
  let vehicle = null;

  // Si tenemos patente o VIN, construimos el objeto vehicle
  if (formData.registration_plate || formData.vin_vis) {
    vehicle = {
      ...(formData.registration_plate && {
        registration_plate: {
          value: formData.registration_plate,
        },
      }),
      ...(formData.vin_vis && {
        vin_vis: {
          value: formData.vin_vis,
        },
      }),
      ...(vehicleDescription && { description: vehicleDescription }),
      ...(formData.model_make_code && { model_make_code: formData.model_make_code }),
      ...(formData.year && { year: formData.year }),
    };
  }

  const medioTrim = formData.medio && String(formData.medio).trim();
  const mediumFromMedio = medioTrim && !isLlamadaMedio(medioTrim) ? medioTrim : "";
  const mediumFromUtm = formData.utm_medium && String(formData.utm_medium).trim();
  const medium = mediumFromMedio || mediumFromUtm || "landing_web";

  return {
    contact: {
      full_name: formData.name || "",
      email: {
        value: formData.email || "",
        type: "work",
      },
      phone: {
        value: cleanPhone,
        type: "work",
        country_code: "AR",
      },
      mobile_phone: {
        value: cleanPhone,
        type: "work",
        country_code: "AR",
      },
    },
    product: formData.brand || "JEEP",
    comments: `${formData.comments || ""}${formData.comments ? " - " : ""}Tipo de operación: ${operationType}${
      vehicleDescription ? ` - Vehículo: ${vehicleDescription}` : ""
    }`,
    medium,
    origin: origin,
    sub_origin: suborigen,
    campaign: formData.desolChannel || formData.campaign || "",
    requested_at: currentDate,
    first_contacted_at: currentDate,
    ...(vehicle && { vehicle }),
  };
};

